<template>
    <path fill-rule="evenodd" d="M16 6.194c-3.42 0-6.194 2.774-6.194 6.193 0 3.42 2.775 6.194 6.194 6.194 3.42 0 6.194-2.775 6.194-6.194 0-3.42-2.775-6.193-6.194-6.193zm0 9.29c-1.71 0-3.097-1.387-3.097-3.097S14.29 9.29 16 9.29s3.097 1.387 3.097 3.097S17.71 15.484 16 15.484zM16 0C7.161 0 0 7.161 0 16s7.161 16 16 16 16-7.161 16-16S24.839 0 16 0zm0 28.903c-3.206 0-6.135-1.18-8.394-3.122.962-1.484 2.607-2.49 4.49-2.549 1.343.413 2.62.62 3.904.62 1.284 0 2.561-.2 3.903-.62 1.884.065 3.53 1.065 4.49 2.549-2.258 1.942-5.187 3.122-8.393 3.122zm10.497-5.426c-1.574-2.025-4.007-3.348-6.78-3.348-.659 0-1.678.62-3.717.62-2.032 0-3.058-.62-3.716-.62-2.768 0-5.2 1.323-6.78 3.348-1.51-2.11-2.407-4.69-2.407-7.477C3.097 8.884 8.884 3.097 16 3.097c7.116 0 12.903 5.787 12.903 12.903 0 2.787-.897 5.368-2.406 7.477z"/>
</template>

<script>
export default {
    name: 'userIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
}
</script>
